import { Outlet, useMatches } from "react-router";
import { matchedHandle, navbarText } from "./handles";
import { Navbar } from "./Navbar";

/**
 * _AuthLayout, for the sign-in and landing pages: the navbar in a <header> (none when the page has its own), then
 * <main>. No error box, as before. The body's class comes from the route (felt-gradient unless the page says).
 */
export function AuthLayout() {
    const handle = matchedHandle(useMatches());

    return (
        <>
            <header>
                {!handle.hideNavbar && <Navbar text={navbarText(handle)} />}
            </header>
            <main>
                <Outlet />
            </main>
        </>
    );
}
